import React from 'react';
import FormHandler from '../FormHandler';
import { StyledTextField } from '../styledComponents';
import { AlertType, TowerAlert } from '../../../common/Alerts';
import isEmpty from 'lodash/isEmpty';
import { useUsername } from '../../slices/hooks/useUsersSlice';
import useFocus from '../hooks/useFocus';
import Typography from '@mui/material/Typography';

interface Props {
    show: boolean;
    onForgotPassword: (email: string) => void;
    isLoading: boolean;
    setAlerts: (v: TowerAlert[]) => void;
}

const ForgotPassword = ({ show, onForgotPassword, isLoading, setAlerts }: Props) => {
    const { username: email, updateUsername: updateEmail } = useUsername();
    const focusInputRef = useFocus();

    if (!show) {
        return <></>;
    }

    const validateInputs = () => {
        const errors: TowerAlert[] = [];
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (isEmpty(email)) {
            errors.push({ type: AlertType.error, message: 'An email is required.' });
        } else if (!emailRegex.test(email)) {
            errors.push({
                type: AlertType.error,
                message: 'Must be a valid email address.',
            });
        }

        setAlerts(errors);
        return errors.length === 0;
    };

    const handleFormSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const isValid = validateInputs();
        if (isValid) {
            onForgotPassword(email);
        }
    };

    return (
        <>
            <Typography variant="h5" mb="25px" gutterBottom style={{ textAlign: 'center' }}>
                Reset your password
            </Typography>
            <FormHandler
                onSubmit={handleFormSubmit}
                buttonText="Next"
                isDisabled={false}
                isLoading={isLoading}
            >
                <StyledTextField
                    fullWidth
                    label="Email"
                    placeholder="Required"
                    variant="standard"
                    margin="normal"
                    value={email}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        updateEmail(e.target.value)
                    }
                    inputRef={focusInputRef}
                />
            </FormHandler>
        </>
    );
};
export default ForgotPassword;
